import React from 'react'

const Title = ({ children, ...props }) => <h4 {...props}>{children}</h4>

Title.displayName = 'Dialog.Title'

export default Title
